// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matchMessage {
  color: #93CDDD;
  font-size: 15px;
  margin-top: 5px;
  margin-bottom: 8px;
}

.errorMessage {
  color: red;
  font-size: 15px;
  margin-top: 5px;
  margin-bottom: 8px;
}

.user-container {
  display: flex;
  height: 100%;
  background-color: var(--color-bg);
  color: var(--color-text);
  padding: 0 20px;
  position: relative;
}
.user-container .user-info-section {
  background-color: var(--color-bg);
  color: var(--color-text);
  padding: 30px;
  width: 50%;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  margin-right: 50%;
  z-index: 1;
}
.user-container .user-info-section .user-info-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
}
.user-container .user-info-section .user-info-header h1 {
  flex-grow: 1;
  font-size: 30px;
  font-weight: bold;
  color: #2DACEC;
}
.user-container .user-info-section .user-info-header .edit-button {
  width: 100px;
  height: 40px;
  background: linear-gradient(145deg, #2196f3, #1976d2);
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  margin-left: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.user-container .user-info-section .user-info-header .edit-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.user-container .user-info-section .user-info-header .edit-button:hover {
  background: linear-gradient(145deg, #1976d2, #1565c0);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
}
.user-container .user-info-section .user-info-header .save-button, .user-container .user-info-section .user-info-header .cancel-button {
  margin-left: 10px;
  width: 100px;
  height: 40px;
  min-width: 100px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  border: none;
}
.user-container .user-info-section .user-info-header .save-button {
  background: linear-gradient(145deg, #2196f3, #1976d2);
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.user-container .user-info-section .user-info-header .save-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.user-container .user-info-section .user-info-header .save-button:hover {
  background: linear-gradient(145deg, #1976d2, #1565c0);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
}
.user-container .user-info-section .user-info-header .cancel-button {
  background: linear-gradient(145deg, #9e9e9e, #757575);
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.user-container .user-info-section .user-info-header .cancel-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.user-container .user-info-section .user-info-header .cancel-button:hover {
  background: linear-gradient(145deg, #757575, #616161);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.user-container .user-info-section .user-info-details .user-info-item {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
}
.user-container .user-info-section .user-info-details .user-info-item label {
  font-size: 16px;
  font-weight: bold;
  width: 180px;
  text-align: right;
  margin-right: 8px;
  flex-shrink: 0;
}
.user-container .user-info-section .user-info-details .user-info-item .user-info-value, .user-container .user-info-section .user-info-details .user-info-item .user-input {
  font-size: 14px;
  padding: 10px 14px;
  background-color: var(--color-bg-muted);
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  color: var(--color-text);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  line-height: 1.4;
  font-family: var(--font-sans);
  display: flex;
  align-items: center;
}
.user-container .user-info-section .user-info-details .user-info-item .modify-button {
  background: linear-gradient(145deg, #ff7675, #e84393);
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  margin-left: 188px;
  width: 200px;
  height: 40px;
}
.user-container .user-info-section .user-info-details .user-info-item .modify-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.user-container .user-info-section .user-info-details .user-info-item .modify-button:hover {
  background: linear-gradient(145deg, #e84393, #fd79a8);
  box-shadow: 0 4px 8px rgba(232, 67, 147, 0.3);
}
.user-container .user-info-section .user-info-details .user-info-item .user-input {
  width: 100%;
  height: 40px;
  padding: 10px 14px;
  box-sizing: border-box;
  border: 1px solid var(--color-field-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  background-color: var(--color-field-bg);
  font-family: var(--font-sans);
  color: var(--color-text);
  transition: border-color var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard);
}
.user-container .user-info-section .user-info-details .user-info-item .user-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-ring);
}
.user-container .user-info-section .user-info-details .user-info-item .user-input::placeholder {
  color: var(--color-field-placeholder);
}
.user-container .user-info-section .user-info-details .password-change-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 5px;
  width: 100%;
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-item {
  display: flex;
  flex-direction: column;
  margin-left: 188px;
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-item label {
  display: block;
  font-size: 15px;
  margin-bottom: 3px;
  text-align: left;
  width: 100%;
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-item .password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-item .password-input-container .user-input {
  width: 100%;
  height: 40px;
  padding: 10px 40px 10px 14px;
  box-sizing: border-box;
  border: 1px solid var(--color-field-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  background-color: var(--color-field-bg);
  font-family: var(--font-sans);
  color: var(--color-text);
  transition: border-color var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard);
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-item .password-input-container .user-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-ring);
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-item .password-input-container .user-input::placeholder {
  color: var(--color-field-placeholder);
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-item .password-input-container .toggle-password {
  position: absolute;
  right: 8px;
  cursor: pointer;
  width: 21px;
  height: 15px;
}
[data-theme=dark] .user-container .user-info-section .user-info-details .password-change-container .password-change-item .password-input-container .toggle-password {
  filter: invert(1) brightness(1.2);
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  margin-left: 188px;
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-buttons .ok-button, .user-container .user-info-section .user-info-details .password-change-container .password-change-buttons .cancel-button {
  background: linear-gradient(145deg, #2196f3, #1976d2);
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  margin-left: 2px;
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-buttons .ok-button:active, .user-container .user-info-section .user-info-details .password-change-container .password-change-buttons .cancel-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-buttons .ok-button:hover {
  background: linear-gradient(145deg, #1976d2, #1565c0);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-buttons .cancel-button {
  background: linear-gradient(145deg, #9e9e9e, #757575);
}
.user-container .user-info-section .user-info-details .password-change-container .password-change-buttons .cancel-button:hover {
  background: linear-gradient(145deg, #757575, #616161);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.user-container .user-image-section {
  width: 600px;
  min-width: 400px;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: var(--color-bg);
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;
}
.user-container .user-image-section .image-overlay-text {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  color: #333;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.user-container .user-image-section .rotating-profile-image {
  width: 350px !important;
  height: 350px !important;
  object-fit: contain;
  animation: rotate_image 120s linear infinite;
  transform-origin: 50% 50%;
  opacity: 0.2;
  z-index: 1;
}

@keyframes rotate_image {
  100% {
    transform: rotate(360deg);
  }
}
.password-btn {
  min-width: 100px;
  height: 40px;
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/pages/User/ProfileStyled.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,UAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,YAAA;EAEA,iCAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;AAFF;AAIE;EACE,iCAAA;EACA,wBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;AAFJ;AAII;EACE,aAAA;EAEA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAHN;AAKM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHR;AAMM;EACE,YAAA;EACA,YAAA;EACA,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,wCAAA;AAJR;AAMQ;EACE,0BAAA;EACA,wCAAA;AAJV;AAOQ;EACE,qDAAA;EACA,6CAAA;AALV;AASM;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EAEA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AARR;AAWM;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AATR;AAWQ;EACE,0BAAA;EACA,wCAAA;AATV;AAYQ;EACE,qDAAA;EACA,6CAAA;AAVV;AAcM;EACE,qDAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAZR;AAcQ;EACE,0BAAA;EACA,wCAAA;AAZV;AAeQ;EACE,qDAAA;EACA,yCAAA;AAbV;AAmBM;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAjBR;AAmBQ;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAjBV;AAoBQ;EACE,eAAA;EACA,kBAAA;EACA,uCAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,+BAAA;EACA,qCAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;AAlBV;AAqBQ;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAnBV;AAqBU;EACE,0BAAA;EACA,wCAAA;AAnBZ;AAsBU;EACE,qDAAA;EACA,6CAAA;AApBZ;AAwBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,2CAAA;EACA,+BAAA;EACA,eAAA;EAEA,uCAAA;EACA,6BAAA;EACA,wBAAA;EACA,4HAAA;AAvBV;AA0BU;EACE,aAAA;EACA,kCAAA;EACA,+CAAA;AAxBZ;AA2BU;EACE,qCAAA;AAzBZ;AA8BM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AA5BR;AA8BQ;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AA5BV;AA8BU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AA5BZ;AA+BU;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA7BZ;AA+BY;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,sBAAA;EACA,2CAAA;EACA,+BAAA;EACA,eAAA;EAEA,uCAAA;EACA,6BAAA;EACA,wBAAA;EACA,4HAAA;AA9Bd;AAiCc;EACE,aAAA;EACA,kCAAA;EACA,+CAAA;AA/BhB;AAkCc;EACE,qCAAA;AAhChB;AAoCY;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAlCd;AAqCc;EACE,iCAAA;AAnChB;AAyCQ;EACE,aAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;AAvCV;AAyCU;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAvCZ;AAyCY;EACE,0BAAA;EACA,wCAAA;AAvCd;AA4CY;EACE,qDAAA;EACA,6CAAA;AA1Cd;AA8CU;EACE,qDAAA;AA5CZ;AA8CY;EACE,qDAAA;EACA,yCAAA;AA5Cd;AAoDE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EAGA,iCAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AApDJ;AAsDI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iDAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AApDN;AAuDI;EACE,uBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4CAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;AArDN;;AA0DA;EACE;IACE,yBAAA;EAvDF;AACF;AA0DA;EACE,gBAAA;EACA,YAAA;EACA,0BAAA;AAxDF","sourcesContent":["// .page-title styling provided globally in src/styles/global.scss (accent bar + bottom hairline).\n\n.matchMessage {\n  color: #93CDDD;\n  font-size: 15px;\n  margin-top: 5px;\n  margin-bottom: 8px;\n}\n\n.errorMessage {\n  color: red;\n  font-size: 15px;\n  margin-top: 5px;\n  margin-bottom: 8px;\n}\n\n.user-container {\n  display: flex;\n  height: 100%;\n  // 토큰화 — 다크모드에서 흰 카드가 다크 페이지에 떠 있던 문제 수정.\n  background-color: var(--color-bg);\n  color: var(--color-text);\n  padding: 0 20px;\n  position: relative;\n\n  .user-info-section {\n    background-color: var(--color-bg);\n    color: var(--color-text);\n    padding: 30px;\n    width: 50%;\n    min-width: 400px;\n    display: flex;\n    flex-direction: column;\n    margin-right: 50%;\n    z-index: 1;\n\n    .user-info-header {\n      display: flex;\n      // justify-content: space-between;\n      justify-content: flex-end;\n      align-items: center;\n      margin-bottom: 20px;\n\n      h1 {\n        flex-grow: 1;\n        font-size: 30px;\n        font-weight: bold;\n        color: #2DACEC;\n      }\n\n      .edit-button {\n        width: 100px;\n        height: 40px;\n        background: linear-gradient(145deg, #2196f3, #1976d2);\n        color: white;\n        border: none;\n        padding: 10px 20px;\n        font-size: 14px;\n        cursor: pointer;\n        border-radius: 6px;\n        transition: all 0.3s ease;\n        margin-left: 10px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      \n        &:active {\n          transform: translateY(1px);\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n        }\n\n        &:hover {\n          background: linear-gradient(145deg, #1976d2, #1565c0);\n          box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);\n        }\n      }\n\n      .save-button, .cancel-button {\n        margin-left: 10px;\n        width: 100px;  // 버튼 너비 고정\n        height: 40px;  // 버튼 높이 고정\n        // 또는\n        min-width: 100px;  // 최소 너비 설정\n        padding: 10px 20px;  // 상하 10px, 좌우 20px 여백\n        font-size: 14px;\n        cursor: pointer;\n        border-radius: 6px;\n        transition: all 0.3s ease;\n        border: none;\n      }\n\n      .save-button {\n        background: linear-gradient(145deg, #2196f3, #1976d2);\n        color: white;\n        border: none;\n        padding: 10px 20px;\n        font-size: 14px;\n        cursor: pointer;\n        border-radius: 6px;\n        transition: all 0.3s ease;\n      \n        &:active {\n          transform: translateY(1px);\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n        }\n\n        &:hover {\n          background: linear-gradient(145deg, #1976d2, #1565c0);\n          box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);\n        }\n      }\n      \n      .cancel-button {\n        background: linear-gradient(145deg, #9e9e9e, #757575);\n        color: #ffffff;\n        border: none;\n        padding: 10px 20px;\n        font-size: 14px;\n        cursor: pointer;\n        border-radius: 6px;\n        transition: all 0.3s ease;\n      \n        &:active {\n          transform: translateY(1px);\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n        }\n\n        &:hover {\n          background: linear-gradient(145deg, #757575, #616161);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n        }\n      }\n    }\n\n    .user-info-details {\n      .user-info-item {\n        margin-bottom: 15px;\n        display: flex;\n        align-items: center;\n        width: 100%;  // 전체 너비를 사용하여 레이아웃 유지\n\n        label {\n          font-size: 16px;\n          font-weight: bold;\n          width: 180px;\n          text-align: right;\n          margin-right: 8px;\n          flex-shrink: 0;  // 레이블 크기 고정\n        }\n\n        .user-info-value, .user-input {\n          font-size: 14px;\n          padding: 10px 14px;\n          background-color: var(--color-bg-muted);\n          width: 100%;\n          height: 40px;\n          box-sizing: border-box;\n          color: var(--color-text);\n          border-radius: var(--radius-md);\n          border: 1px solid var(--color-border);\n          line-height: 1.4;\n          font-family: var(--font-sans);\n          display: flex;\n          align-items: center;\n        }\n\n        .modify-button {\n          background: linear-gradient(145deg, #ff7675, #e84393);\n          color: white;\n          border: none;\n          padding: 10px 20px;\n          font-size: 14px;\n          cursor: pointer;\n          border-radius: 6px;\n          transition: all 0.3s ease;\n          margin-left: 188px; // 시작위치\n          width: 200px;\n          height: 40px;\n\n          &:active {\n            transform: translateY(1px);\n            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n          }\n\n          &:hover {\n            background: linear-gradient(145deg, #e84393, #fd79a8);\n            box-shadow: 0 4px 8px rgba(232, 67, 147, 0.3);\n          }\n        }\n\n        .user-input {\n          width: 100%;\n          height: 40px;\n          padding: 10px 14px;\n          box-sizing: border-box;\n          border: 1px solid var(--color-field-border);\n          border-radius: var(--radius-md);\n          font-size: 14px;\n          // --color-bg 는 다크모드에서 페이지 배경과 동색이라 입력칸이 사라집니다.\n          background-color: var(--color-field-bg);\n          font-family: var(--font-sans);\n          color: var(--color-text);\n          transition: border-color var(--duration-base) var(--easing-standard),\n                      box-shadow var(--duration-base) var(--easing-standard);\n\n          &:focus {\n            outline: none;\n            border-color: var(--color-primary);\n            box-shadow: 0 0 0 3px var(--color-primary-ring);\n          }\n\n          &::placeholder {\n            color: var(--color-field-placeholder);\n          }\n        }\n      }\n\n      .password-change-container {\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n        margin-top: 5px;\n        width: 100%;\n\n        .password-change-item {\n          display: flex;\n          flex-direction: column;\n          margin-left: 188px; // 시작위치\n\n          label {\n            display: block;\n            font-size: 15px;\n            margin-bottom: 3px;\n            text-align: left;\n            width: 100%;\n          }\n\n          .password-input-container {\n            position: relative;\n            display: flex;\n            align-items: center;\n\n            .user-input {\n              width: 100%;\n              height: 40px;\n              padding: 10px 40px 10px 14px;\n              box-sizing: border-box;\n              border: 1px solid var(--color-field-border);\n              border-radius: var(--radius-md);\n              font-size: 14px;\n              // --color-bg 는 다크모드에서 페이지 배경과 동색이라 입력칸이 사라집니다.\n              background-color: var(--color-field-bg);\n              font-family: var(--font-sans);\n              color: var(--color-text);\n              transition: border-color var(--duration-base) var(--easing-standard),\n                          box-shadow var(--duration-base) var(--easing-standard);\n\n              &:focus {\n                outline: none;\n                border-color: var(--color-primary);\n                box-shadow: 0 0 0 3px var(--color-primary-ring);\n              }\n\n              &::placeholder {\n                color: var(--color-field-placeholder);\n              }\n            }\n\n            .toggle-password {\n              position: absolute;\n              right: 8px;\n              cursor: pointer;\n              width: 21px;\n              height: 15px;\n              // PNG라 CSS color는 무효 — 다크모드에선 어두운 아이콘이 어두운 배경에\n              // 묻혀버리므로 filter로 반전시켜 밝은 아이콘으로 보이게.\n              [data-theme=\"dark\"] & {\n                filter: invert(1) brightness(1.2);\n              }\n            }\n          }\n        }\n\n        .password-change-buttons {\n          display: flex;\n          gap: 8px;  // save, cancel 버튼과 동일한 간격\n          justify-content: flex-start;\n          margin-left: 188px;  // 다른 요소들과 동일한 시작 위치로 정렬\n\n          .ok-button, .cancel-button {\n            background: linear-gradient(145deg, #2196f3, #1976d2);\n            color: white;\n            border: none;\n            padding: 10px 20px;\n            font-size: 14px;\n            cursor: pointer;\n            border-radius: 6px;\n            transition: all 0.3s ease;\n            margin-left: 2px;  // save, cancel 버튼과 동일한 간격\n            \n            &:active {\n              transform: translateY(1px);\n              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n            }\n          }\n\n          .ok-button {\n            &:hover {\n              background: linear-gradient(145deg, #1976d2, #1565c0);\n              box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);\n            }\n          }\n          \n          .cancel-button {\n            background: linear-gradient(145deg, #9e9e9e, #757575);\n            \n            &:hover {\n              background: linear-gradient(145deg, #757575, #616161);\n              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .user-image-section {\n    width: 600px;\n    min-width: 400px;\n    height: 500px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    // 토큰화 — 페이지 하단까지 fixed로 깔리는 흰 strip 제거 (다크에선 자동으로\n    // slate-900가 되어 페이지 배경과 통합).\n    background-color: var(--color-bg);\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 0;\n    \n    .image-overlay-text {\n      position: absolute;\n      top: 20px;\n      left: 50%;\n      transform: translateX(-50%);\n      z-index: 2;\n      color: #333;\n      font-size: 24px;\n      font-weight: bold;\n      text-align: center;\n      text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);\n      pointer-events: none;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n    }\n\n    .rotating-profile-image {\n      width: 350px !important;\n      height: 350px !important;\n      object-fit: contain;\n      animation: rotate_image 120s linear infinite;\n      transform-origin: 50% 50%;\n      opacity: 0.2;\n      z-index: 1;  // 이미지의 z-index를 문구보다 낮게 설정\n    }\n  }\n}\n\n@keyframes rotate_image {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.password-btn {\n  min-width: 100px;  // 버튼 최소 너비 설정\n  height: 40px;\n  text-transform: capitalize;  // 첫 글자 대문자로\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
